/**
 * Checks if the user prefers reduced motion.
 * @returns {boolean} True if the user prefers reduced motion, false otherwise.
 */
export function prefersReducedMotion() {
  return (
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  );
}
